import Rails from "@rails/ujs"

if (!window.Rails) {
  Rails.start()
  window.Rails = Rails
}
